import { CheckupRequestStatusResponse } from "@companion-professional/dctypes";
import { Row } from "@tanstack/react-table";

const PriorityMapForSortingAnalysisStatus:  {[key: string]: number} = {
    'gait_anomaly': 4,
    'processing': 3, 
    'no_anomaly_detected': 2,
    'not_started': 1
  };

/**
 * Given two rows, rowA and rowB, return a positive value if rowA should sort above rowB in the table, a 0 if there's a tie,
 * and a negative number of rowB should sort above rowA.
 * 
 * It use priority map to sort by the analysis statuses first.
 * If the analysis statuses are the same, use uploaded_at for tie-breaker
 * If both uploaded_at are null, use request_created for tie-breaker
 */
export const analysisPrioritySort = (rowA: Row<CheckupRequestStatusResponse>, rowB: Row<CheckupRequestStatusResponse>) => {{
    const analysisStatusA = rowA.getValue('analysis_status') as string;
    const analysisStatusB = rowB.getValue('analysis_status') as string;
  
    const priorityA = PriorityMapForSortingAnalysisStatus[analysisStatusA] || 0;
    const priorityB = PriorityMapForSortingAnalysisStatus[analysisStatusB] || 0;
    // With descending sort, higher priority (higher number) comes first
    if (priorityA !== priorityB) {
      return priorityA - priorityB;
    }
   
    // If same priority, use uploaded_at for tie-breaker
    const uploadTimeA = rowA.getValue('uploaded_at') as string;
    const uploadTimeB = rowB.getValue('uploaded_at') as string;        
    
    // If both have uploaded_at, sort by upload time (descending)
    if (uploadTimeA && uploadTimeB) {
      return new Date(uploadTimeA).getTime() - new Date(uploadTimeB).getTime();
    }
    
    // If only one has uploaded_at, the one with uploaded_at comes first
    if (uploadTimeA && !uploadTimeB) return 1;
    if (!uploadTimeA && uploadTimeB) return -1;
    
    // when both upload_at are null, use request_created as tie-breaker
    const requestTimeA = rowA.getValue('request_created') as string;
    const requestTimeB = rowB.getValue('request_created') as string;
    return new Date(requestTimeA).getTime() - new Date(requestTimeB).getTime();
  }
}
